import React from "react";
//Feather
import {
  PhoneIncoming
} from 'react-feather';

export default function PhoneNumber({ title, name, value, register, qtd, lastOne, children }) {

  if(lastOne == "true"){
    return (
      <label className={`label-telefone ${value}`}>
        <input hidden type="radio" name={name} value={value} {...register(name)}/>
        <span><PhoneIncoming size={18}></PhoneIncoming><div className="mr-10">{children}</div> {title} <br/> Qtd chamadas: {qtd ? qtd : 0 } </span>
        <div align="center"></div>
      </label>
    );
  } else {
    return (
      <label className={`label-telefone ${value}`}>
        <input hidden type="radio" name={name} value={value} {...register(name)}/>
        <span><div className="mr-10">{children}</div> {title} <br/> Qtd chamadas: {qtd ? qtd : 0 }</span>
      </label>
    );
  }
}